import { useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Box, Drawer, Stack, styled, Typography } from '@mui/material';
import useResponsive from '../../hooks/useResponsive';
import config from './config';

const NAV_WIDTH = 280;

const NavItem = styled(Typography)`
  cursor: pointer;

  a {
    text-transform: none;
    text-decoration: none;

    &:visited,
    &:link {
      color: white;
    }

    &:hover {
      color: #aaf27f;
    }
  }
`;

export default function Nav({ openNav, onCloseNav }) {
  const { pathname } = useLocation();

  const isDesktop = useResponsive('up', 'lg');

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Box
      height="100%"
      bgcolor="primary.main"
      padding={4}
      display="flex"
      flexDirection="column"
      justifyContent="space-between">
      <Stack color="common.white" gap={3}>
        <Typography variant="h4">SNORY</Typography>
        {config.map(({ title, route }) => (
          <NavItem key={title} variant="body1">
            <NavLink
              style={({ isActive }) => (isActive ? { color: '#aaf27f' } : undefined)}
              to={route}>
              {title}
            </NavLink>
          </NavItem>
        ))}
      </Stack>
      <Box>
        <Typography variant="caption" display="block" color="common.white" sx={{ opacity: 0.7 }}>
          Powered by
        </Typography>
        <Typography variant="subtitle1" fontWeight="bold">
          <a
            href="https://bluetouch.dev/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'white', textDecoration: 'none' }}>
            BlueTouch
          </a>
        </Typography>
        <Typography
          variant="caption"
          display="block"
          color="common.white"
          sx={{ opacity: 0.7, marginTop: 1 }}>
          Need help or new features? <br />
          <a
            href="https://bluetouch.dev/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'white', textDecoration: 'underline' }}>
            Contact us
          </a>
        </Typography>
      </Box>
    </Box>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV_WIDTH }
      }}>
      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              width: NAV_WIDTH,
              bgcolor: 'background.default',
              borderRightStyle: 'dashed'
            }
          }}>
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true
          }}
          PaperProps={{
            sx: { width: NAV_WIDTH }
          }}>
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
